import React from 'react';

const Spinner = () => (
  <div className="loading-spinner-container container-component">
    <div className="loading-spinner spinner-component" />
  </div>);

export default Spinner;
